// extracted by mini-css-extract-plugin
module.exports = {"main":"Content_main__Iv4Zl","newMain":"Content_newMain__bd1y8"};